import { useMenuState } from 'src/providers/MenuStateProvider'
import { UserProviderUserType } from 'src/providers/UserProvider'

import { DefaultAvatar } from 'src/components/atoms/Icons/DefaultAvatar'
import { OnClickLink } from 'src/components/atoms/Link'
import { Heading3 } from 'src/components/atoms/Typography'

import { useGetUserAndMembershipsQuery } from 'src/config/generated/graphql'
import { env } from 'src/env/client.mjs'
import { AccountType } from 'src/types/account'

const DEFAULT_PROFILE = 'assets/img/default-profile.png'

type DashboardHeaderProps = {
  user?: UserProviderUserType
}

export const DashboardHeader = ({ user }: DashboardHeaderProps) => {
  const { setIsOpen } = useMenuState()

  const { data: membershipData } = useGetUserAndMembershipsQuery({
    variables: {
      id: user?.Id
    }
  })

  return (
    <div className='flex flex-col md:flex-row gap-[10px] sm:gap-5 items-start md:items-center'>
      {user?.Account?.Avatar && user?.Account?.Avatar !== DEFAULT_PROFILE ? (
        <div
          className='bg-contain rounded-full overflow-hidden relative w-[60px] h-[60px] md:w-[100px] md:h-[100px]'
          style={{
            backgroundImage: `url(${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${user?.Account?.Avatar})`
          }}
        />
      ) : (
        <div className='overflow-hidden self-start text-white rounded-full bg-mostlyGreen'>
          <DefaultAvatar className='w-[60px] h-[60px] md:w-[70px] md:h-[70px] m-[10px] md:m-[15px]' />
        </div>
      )}
      <div className='flex flex-col flex-1 gap-[5px]'>
        <Heading3 className='!m-0 !text-[18px] !leading-[26px] sm:!text-[28px] sm:!leading-[39px] !font-semibold'>
          Kia ora {user?.FirstName ? `${user?.FirstName}` : ''}
        </Heading3>
        <span className='text-[14px] leading-[20px] sm:text-[16px] sm:leading-[24px] font-medium'>
          {user?.Account && user?.Account?.Type !== AccountType.IndividualFamily
            ? `${user.Account.Name} • ${user.ActiveProfileType}`
            : `${user?.ActiveProfileType}`}
          {(membershipData?.Membership.length || 0) > 1 ||
          membershipData?.Membership.some(
            m => m.Account.FunderId && m.Account.PlanterId
          ) ? (
            <>
              {' • '}
              <OnClickLink
                onClick={() => {
                  window.scrollTo({
                    top: 0
                  })
                  setIsOpen(true, true)
                }}
              >
                Switch account
              </OnClickLink>
            </>
          ) : null}
        </span>
      </div>
    </div>
  )
}
